import { useCallback } from "react";

import { usePolicyStore } from "../../../../store/policyStore";
import CodeEditor from "../CodeEditor";
import { DEFAULT_DOCUMENT, EXAMPLE_DOCUMENT } from "../utils";

export const RulesView: React.FC<{
  canSubmit: boolean;
  handleSubmitWorkflow: (value: string) => Promise<void>;
  filteredYaml?: string;
}> = ({ canSubmit, handleSubmitWorkflow, filteredYaml }) => {
  const { yamlRules, setYamlRules } = usePolicyStore();
  const displayedYaml = filteredYaml ?? yamlRules;

  const setDefaultRules = useCallback(
    () => setYamlRules(DEFAULT_DOCUMENT),
    [setYamlRules]
  );
  const setExampleRules = useCallback(
    () => setYamlRules(EXAMPLE_DOCUMENT),
    [setYamlRules]
  );
  return (
    <>
      <CodeEditor
        rule={displayedYaml}
        setDefaultRule={filteredYaml ? undefined : setDefaultRules}
        setSampleExample={filteredYaml ? undefined : setExampleRules}
        handleSubmitWorkflow={canSubmit ? handleSubmitWorkflow : undefined}
      />
    </>
  );
};
